module.exports = __webpack_public_path__ + "img/6.dc5d19e3.jpg";